(ns teamoesterreich.user-mode.landing.news.news
  (:require
    [clojure.string]
    [goog.date.DateTime]
    [reagent-material-ui.components :as mui]
    [reagent.core :as r]
    [teamoesterreich.config :as config]
    [teamoesterreich.store :as store]
    [teamoesterreich.text.get-text :as txt]
    [teamoesterreich.user-mode.backend :as backend]
    [teamoesterreich.util.log :as log]))



(defn articles-title []
  [mui/grid
   {:item  true
    :xs    12
    :style {:padding    "0 20px 0 20px"
            :alignItems "center"}
    }

   [:h2
    {:style {;:maxWidth "1165px"
             :padding "3px" :color "#000000de"}}
    (txt/transl "Berichte")]]

  )

(defn blob-widget [uuid blog]


  [mui/grid
   {:container false
    :item      true
    :xs        12
    :style     {:marginBottom "5px"}
    }
   [mui/card
    [mui/card-header
     {:title
      (r/as-element [mui/grid
                     {:container  true
                      :direction  "row"
                      :alignItems "stretch"
                      :justify    "flex-start"
                      }
                     [mui/grid
                      {:item  true
                       :md    3
                       :xs    12
                       :style {:textAlign "left" :paddingRight "15px"}
                       }
                      [:img {:src (:header-image-uri blog) :alt "Kein Bild" :width "100%"}]
                      ]

                     [mui/grid
                      {:item  true
                       :md    9
                       :xs    12
                       :style {:minHeight "120px" :textAlign "left" :fontSize "0.6em"}
                       }
                      [:h3 (str (:title blog) " ")]
                      [:h4 {:style {:marginTop "-8px"}} (str (.toLocaleDateString (js/Date. (* 1000 (.-seconds ^js (:date blog))))) (when-not (get blog :published) " - [unveröffentlicht]"))]
                      [:div {:dangerouslySetInnerHTML {:__html (get blog :long-content)}}]
                      ]]
                    )}]
    ]]

  )


(defn get-it []
  (log/debug "get-news" config/CLIENT)
  (let [!publisher (r/cursor store/app-state [:actual-user :publisher])
        !publisher-mode (r/cursor store/app-state [:actual-user :publisher-mode])
        show-unpublished? (and @!publisher @!publisher-mode)]
    (case config/CLIENT

      "toe"
      [mui/grid
       {:item true}
       [:div
        [:ul#ss-storyList.storyList.site
         [:li.storyListItem.indent
          [:a {:href "https://oe3.orf.at/teamoesterreich/stories/teamoesterreich/"} [:img.titleImage {:src "https://tubestatic.orf.at/static/images/site/tube/20141044/toet3.5301075.jpg" :alt "Team Österreich Logo" :title "© Hitradio Ö3" :width "239" :height "134"}]]
          [:div.storyBox
           [:h2 [:a {:href "https://oe3.orf.at/teamoesterreich/stories/teamoesterreich/"} "Team Österreich"]]
           [:p.listItemText "„Wenn ich gebraucht werde, dann bin ich da!“ Das sagen mehr als 95.000 Menschen im ganzen Land, die sich beim Team Österreich angemeldet haben. Sie helfen ehrenamtlich, spontan und flexibel.&nbsp;&nbsp;" [:a {:href "https://oe3.orf.at/teamoesterreich/stories/teamoesterreich/"} [:img.moreLink {:src "https://tubestatic.orf.at/mojo/1_3/storyserver//tube/oe3/images/arrow.right.png" :alt "mehr…" :title ""}]]]
           [:div.clearer]]]
         [:li.storyListItem.indent
          [:a {:href "https://oe3.orf.at/teamoesterreich/stories/teilteamoesterreich/"} [:img.titleImage {:src "https://tubestatic.orf.at/static/images/site/tube/20130834/helfer_2_websys.5172929.jpg" :alt "Helfer, werde Teil des Team Österreich, Quelle: Facebook" :title "© Hitradio Ö3" :width "239" :height "134"}]]
          [:div.storyBox
           [:h2 [:a {:href "https://oe3.orf.at/teamoesterreich/stories/teilteamoesterreich/"} "Team Österreich: Anmelden"]]
           [:p.listItemText "Du willst beim Team Österreich dabei sein? Weil du etwa bei Katastrophensituationen wie Unwettern anpacken, bei der Team Österreich Tafel Lebensmittel vor der Tonne retten oder einfach Menschen in Notlagen unterstützen willst? Perfekt - melde dich hier gleich an!&nbsp;&nbsp;" [:a {:href "https://oe3.orf.at/teamoesterreich/stories/teilteamoesterreich/"} [:img.moreLink {:src "https://tubestatic.orf.at/mojo/1_3/storyserver//tube/oe3/images/arrow.right.png" :alt "mehr…" :title ""}]]]
           [:div.clearer]]]
         [:li.storyListItem.indent
          [:a {:href "https://oe3.orf.at/teamoesterreich/stories/teamoesterreich-tafel/"} [:img.titleImage {:src "https://tubestatic.orf.at/static/images/site/tube/20130939/team3.5185555.jpg" :alt "Gebäck, im Hintergrund das Team Österreich Logo" :title "© Österreichisches Rotes Kreuz" :width "239" :height "134"}]]
          [:div.storyBox
           [:h2 [:a {:href "https://oe3.orf.at/teamoesterreich/stories/teamoesterreich-tafel/"} "Team Österreich: Tafel"]]
           [:p.listItemText "Seit 2010 rettet die Team Österreich Tafel Lebensmittel und zeigt eindrucksvoll, was das Team Österreich kann: Die flexible Zeitspende führt Überschuss und Mangel zusammen und ermöglicht die Tafel als verlässliche Anlaufstelle für Menschen in Notlagen.&nbsp;&nbsp;" [:a {:href "https://oe3.orf.at/teamoesterreich/stories/teamoesterreich-tafel/"} [:img.moreLink {:src "https://tubestatic.orf.at/mojo/1_3/storyserver//tube/oe3/images/arrow.right.png" :alt "mehr…" :title ""}]]]
           [:div.clearer]]]
         [:li.storyListItem.indent
          [:a {:href "https://oe3.orf.at/teamoesterreich/stories/2925668/"} [:img.titleImage {:src "https://tubestatic.orf.at/static/images/site/tube/20180730/apps.5777612.jpg" :alt "Team Österreich App" :title "© Hitradio Ö3" :width "239" :height "134"}]]
          [:div.storyBox
           [:h2 [:a {:href "https://oe3.orf.at/teamoesterreich/stories/2925668/"} "Team Österreich: App"]]
           [:p.listItemText "Die Team Österreich App ist eine Art digitale Drehscheibe der Vorbereitung, der Warnung und im Bedarfsfall auch der konkreten Hilfe im Krisenfall.&nbsp;&nbsp;" [:a {:href "https://oe3.orf.at/teamoesterreich/stories/2925668/"} [:img.moreLink {:src "https://tubestatic.orf.at/mojo/1_3/storyserver//tube/oe3/images/arrow.right.png" :alt "mehr…" :title ""}]]]
           [:div.clearer]]]
         [:li.storyListItem.indent
          [:a {:href "https://oe3.orf.at/teamoesterreich/stories/teamoesterreichimeinsatz/"} [:img.titleImage {:src "https://tubestatic.orf.at/static/images/site/tube/20130834/hj3h2520-2048_websys.5172921.jpg" :alt "Team Österreich, So hilft &quot;Team Österreich&quot;" :title "© Hitradio Ö3" :width "239" :height "134"}]]
          [:div.storyBox
           [:h2 [:a {:href "https://oe3.orf.at/teamoesterreich/stories/teamoesterreichimeinsatz/"} "Team Österreich: Einsatz"]]
           [:p.listItemText "Schau dir hier an, wie dein Einsatz beim Team Österreich ausschauen könnte und was die ehrenamtlichen Helferinnen und Helfer in den vergangenen Jahren schon geleistet haben, etwa bei Aufräumarbeiten nach Unwettern.&nbsp;&nbsp;" [:a {:href "https://oe3.orf.at/teamoesterreich/stories/teamoesterreichimeinsatz/"} [:img.moreLink {:src "https://tubestatic.orf.at/mojo/1_3/storyserver//tube/oe3/images/arrow.right.png" :alt "mehr…" :title ""}]]]
           [:div.clearer]]]
         [:li.storyListItem.indent
          [:a {:href "https://oe3.orf.at/teamoesterreich/stories/service/"} [:img.titleImage {:src "https://tubestatic.orf.at/static/images/site/tube/20130939/20130603_pd9020.hr.5185707.jpg" :alt "Hoichwasser Hinweisschild" :title "© Bildagentur Waldhaeusl / Waldhäusl / picturedesk.com" :width "239" :height "134"}]]
          [:div.storyBox
           [:h2 [:a {:href "https://oe3.orf.at/teamoesterreich/stories/service/"} "Team Österreich: Service"]]
           [:p.listItemText "Das Team Österreich hilft dir auch mit passenden Vorbereitungs-Tipps: Viele Folgen von Katastrophensituationen können entschärft werden, wenn wir alle schon vorher oft einfache Maßnahmen setzen bzw. Verhaltensregeln beachten.&nbsp;&nbsp;" [:a {:href "https://oe3.orf.at/teamoesterreich/stories/service/"} [:img.moreLink {:src "https://tubestatic.orf.at/mojo/1_3/storyserver//tube/oe3/images/arrow.right.png" :alt "mehr…" :title ""}]]]
           [:div.clearer]]]
         [:li.storyListItem.indent
          [:a {:href "https://oe3.orf.at/teamoesterreich/stories/3000477/"} [:img.titleImage {:src "https://tubestatic.orf.at/static/images/site/tube/20200313/toe3.5929415.jpg" :alt "&quot;Team Österreich&quot;-Profilbild-Rahmen" :title "© Facebook" :width "239" :height "134"}]]
          [:div.storyBox
           [:h2 [:a {:href "https://oe3.orf.at/teamoesterreich/stories/3000477/"} "Team Österreich: Facebook-Rahmen"]]
           [:p.listItemText "Mit ein paar Klicks kannst auch du auf Facebook anderen zeigen, dass du als Mitglied im „Team Österreich“ da bist, wenn andere dich brauchen.&nbsp;&nbsp;" [:a {:href "https://oe3.orf.at/teamoesterreich/stories/3000477/"} [:img.moreLink {:src "https://tubestatic.orf.at/mojo/1_3/storyserver//tube/oe3/images/arrow.right.png" :alt "mehr…" :title ""}]]]
           [:div.clearer]]]]
        ]
       ]

      "tbonn"
      (let [!bonn-posts (r/cursor store/app-state [:bonn-posts])
            blog-list (reverse (sort-by (fn [[uuid n]] (.-seconds ^js (:date n))) @!bonn-posts))]
        (log/debug "!blog-list" (clj->js @!bonn-posts))
        (when-not @!bonn-posts (backend/get-bonn-posts))
        [mui/grid
         {:item  true

          :xl    8
          :xs    12
          :style {:width "100%" :maxWidth "1165px" :paddingLeft "3px"}
          }
         [mui/grid
          {:container  true
           :direction  "row"
           :justify    "center"
           :alignItems "stretch"
           }
          (for [[uuid blog] (reverse (sort-by (fn [[uuid blob]] (:date blob))
                                              (if show-unpublished?
                                                (filter (fn [[uuid blob]] (and (:active blob))) blog-list)
                                                (filter (fn [[uuid blob]] (and (:active blob)
                                                                               (:published blob))) blog-list))))]
            ^{:key (str "blob-block-" uuid)} [blob-widget uuid (assoc blog
                                                                 :date (.fromDate js/firebase.firestore.Timestamp (js/Date. (:date blog)))
                                                                 )])
          ]]

        )




      ;bayern
      (let [!blog-list (r/cursor store/app-state [:blog])
            blog-list (reverse (sort-by (fn [[uuid n]] (.-seconds ^js (:date n))) @!blog-list))]
        (log/debug "!blog-list" @!blog-list config/CLIENT)
        [mui/grid
         {:item  true

          :xl    8
          :xs    12
          :style {:width "100%" :maxWidth "1165px" :paddingLeft "3px"}
          }
         [mui/grid
          {:container  true
           :direction  "row"
           :justify    "center"
           :alignItems "stretch"
           }


          (for [[uuid blog] (if show-unpublished?
                              (filter (fn [[uuid blob]] (and (:active blob)
                                                             (< (* (.-seconds ^js (:date blob)) 1000) (js/Date.now))
                                                             )) blog-list)
                              (filter (fn [[uuid blob]] (and (:active blob)
                                                             (:published blob)
                                                             (< (* (.-seconds ^js (:date blob)) 1000) (js/Date.now))
                                                             )) blog-list))]
            ^{:key (str "blob-block-" uuid)} [blob-widget uuid blog])
          ]]

        ))))
